var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/55bf3e3d59acb68913656fb6e8595f53.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8197d59542199ab6a49bc1db79bfabbe.js').default;
var scope_2 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8971c6bfac58391de363e3e87c830ec2.js').default;
var scope_3 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    